import React, { ReactNode } from "react";
import { Card } from "../Card";
import { Box, Typography } from "@mui/material";
import {vars} from '../Variables'

interface IDefaultInfoCard {
  icon: ReactNode;
  children: ReactNode;
  buttonText?: string;
  mandatory?: boolean;
}

export const DefaultInfoCard: React.FC<IDefaultInfoCard> = (props) => {
  const { icon, children, mandatory = false } = props;
  const flexStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const style = {
    ...flexStyle,
    minHeight: '295px',
    position: 'relative',

    '& > div > .MuiTypography-root': {
      fontFamily: vars.primaryFont,
      color: '#4B4B4B',
      textAlign: 'center',
      fontWeight: 500,
    },
  };
  return (
    <Card sx={style} disableHeader>
      {mandatory && <Typography sx={{
        position: 'absolute',
        top: 0,
        fontSize: 13,
        px: 1.5,
        py: 0.5,
        color: '#fff',
        borderTopRightRadius: 7,
        borderBottomLeftRadius: 7,
        right: 0,
        background: '#00C385'
      }}>Mandatory</Typography>}
      {icon}
      <Box sx={flexStyle} mt={3}>
        {children}
      </Box>
    </Card>
  )
}